/**
 *
 * @param string the string to trim
 * @return string the same string with slashes removed
 */
export const trimSlashes = (string: string) => {
  if (string === undefined) throw new Error("No string supplied to trim")
  string = string.trim()

  if (string.startsWith("/")) {
    string = string.substring(1)
  }
  if (string.endsWith("/")) {
    string = string.substring(0, string.length - 1)
  }

  // if we somehow have double slashes, repeat the process
  if (string.startsWith("/") || string.endsWith("/")) {
    string = trimSlashes(string)
  }

  return string
}

/**
 *
 * @description returns a string representing the url of the gatsby api endpoint - by default this is /api but can be overriden by setting the  GATSBY_LAMBDA_ROUTE environment varible (you should not need to do this unless you are doing something wierd.
 * @param suffix the specific lambda to hit. if not supplied then the api root will be returned
 * @return a url for the current site lambda. Ususally relative but possibly absolute if GATSBY_LAMBDA_ROUTE is set
 */

export const getLambdaRoute = (suffix: string = ""): string => {
  let route
  const trimmedSuffix = trimSlashes(suffix)
  if (process.env.GATSBY_LAMBDA_ROUTE) {
    route = new URL(process.env.GATSBY_LAMBDA_ROUTE).toString()
    // trim trailing slash
    route = trimSlashes(route)
  } else if (process.env.DEPLOY_URL) {
    route = process.env.DEPLOY_URL + "/api"
  } else {
    route = "/api"
  }

  if (trimmedSuffix) return route + "/" + trimmedSuffix
  return route
}
